<template>
  <div>
    <OverlayExpiracion />
    <router-view />
  </div>
</template>

<script>
import AOS from "aos";
import OverlayExpiracion from '@/components/OverlayExpiracion.vue'
export default {
  components:{
    OverlayExpiracion
  },
  mounted() {
    AOS.init({
      duration: 1200,
    });
  },
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app {
  font-family: "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1e1e1e;
}

input{
  z-index: 1 !important;
}

a {
  text-decoration: none !important;
}

p {
  margin: 0 !important;
    cursor: default;
}

.swal2-title {
  font-family: Poppins;
  font-size: 1.5em;
  color: #333;
}

.swal2-html-container {
  font-family: Poppins;
  font-size: 1em;
  color: #666;
}

.swal2-confirm,
.swal2-cancel {
  font-family: Poppins;
  font-size: 1em;
  color: #fff;
  background: #01354a;
}

@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-Thin.ttf") format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-ThinItalic.ttf") format("truetype");
  font-weight: 100;
  font-style: italic;
}

/* Raleway Extra Light */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-ExtraLight.ttf") format("truetype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-ExtraLightItalic.ttf")
    format("truetype");
  font-weight: 200;
  font-style: italic;
}

/* Raleway Light */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-Light.ttf") format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-LightItalic.ttf") format("truetype");
  font-weight: 300;
  font-style: italic;
}

/* Raleway Regular */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-Italic.ttf") format("truetype");
  font-weight: 400;
  font-style: italic;
}

/* Raleway Medium */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-MediumItalic.ttf")
    format("truetype");
  font-weight: 500;
  font-style: italic;
}

/* Raleway SemiBold */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-SemiBoldItalic.ttf")
    format("truetype");
  font-weight: 600;
  font-style: italic;
}

/* Raleway Bold */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-BoldItalic.ttf") format("truetype");
  font-weight: 700;
  font-style: italic;
}

/* Raleway Extra Bold */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-ExtraBold.ttf") format("truetype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-ExtraBoldItalic.ttf")
    format("truetype");
  font-weight: 800;
  font-style: italic;
}

/* Raleway Black */
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-Black.ttf") format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Raleway";
  src: url("~@/assets/fonts/Raleway/Raleway-BlackItalic.ttf") format("truetype");
  font-weight: 900;
  font-style: italic;
}

/* Poppins Thin */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-Thin.ttf") format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-ThinItalic.ttf") format("truetype");
  font-weight: 100;
  font-style: italic;
}

/* Poppins Extra Light */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-ExtraLight.ttf") format("truetype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-ExtraLightItalic.ttf")
    format("truetype");
  font-weight: 200;
  font-style: italic;
}

/* Poppins Light */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-Light.ttf") format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-LightItalic.ttf") format("truetype");
  font-weight: 300;
  font-style: italic;
}

/* Poppins Regular */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-Italic.ttf") format("truetype");
  font-weight: 400;
  font-style: italic;
}

/* Poppins Medium */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-MediumItalic.ttf")
    format("truetype");
  font-weight: 500;
  font-style: italic;
}

/* Poppins SemiBold */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf")
    format("truetype");
  font-weight: 600;
  font-style: italic;
}

/* Poppins Bold */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-BoldItalic.ttf") format("truetype");
  font-weight: 700;
  font-style: italic;
}

/* Poppins Extra Bold */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-ExtraBold.ttf") format("truetype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-ExtraBoldItalic.ttf")
    format("truetype");
  font-weight: 800;
  font-style: italic;
}

/* Poppins Black */
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-Black.ttf") format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/fonts/Poppins/Poppins-BlackItalic.ttf") format("truetype");
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: "Inter";
  src: url("~@/assets/fonts/Inter/Inter_24pt-Regular.ttf") format("truetype");
  font-weight: 500;
}

@font-face {
  font-family: "Inter";
  src: url("~@/assets/fonts/Inter/Inter_24pt-SemiBold.ttf") format("truetype");
  font-weight: 600;
}
</style>
